import type {
  SafeParseError,
  SafeParseReturnType,
  ZodInvalidTypeIssue,
} from "zod";

export function zodErrorDisplay<T>(parseResult: SafeParseError<T>) {
  if (parseResult.success) {
    return; // There is nothing to format (shouldn't ever happen but just in case)
  }

  return parseResult.error.issues.reduce((result, curr) => {
    const current = curr as ZodInvalidTypeIssue;
    result[current.path.join(".")] =
      `Error Code [${current.code}] expected [${current.expected}] recieved [${current.received}] Message [${current.message}]`;
    return result;
  }, {});
}

export type ExtractFromeSafeParse<T> =
  T extends SafeParseError<infer X> ? X : never;

export class LAMValidationError<Input, Output> extends Error {
  constructor(
    eventName: string,
    validationResult: SafeParseReturnType<Input, Output>
  ) {
    const formattedErrors = JSON.stringify(
      zodErrorDisplay(
        validationResult as SafeParseError<
          // Seems TS has an issue with the type union here
          ExtractFromeSafeParse<typeof validationResult> // Here this is made to extrac the generic from the result
        >
      ),
      undefined,
      "\n"
    );
    super(formattedErrors, { cause: validationResult });
    this.name = `LAMValidationError(${eventName})`;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, LAMValidationError);
    }
  }
}

export function dispatchError<
  T extends Error,
  U extends { dispatch: (...args) => Promise<void> },
>(instance: U, error: T) {
  instance.dispatch({
    type: "analytics-error",
    error,
  });
}
